<template>
  <div class="dialog-wrapper">
    <el-dialog
      :title="isEdit ? '编辑专家' : '添加专家'"
      :visible.sync="isShow"
      width="680px"
      :close-on-click-modal="false"
      :before-close="handleBeforeClose"
    >
      <div class="expert-action-wrapper">
        <vue-scroll :ops="ops">
          <el-form
            ref="expertForm"
            class="expert-form"
            :model="formData"
            :rules="formRules"
            label-width="160px"
          >
            <el-form-item label="专家姓名" prop="idName">
              <el-input
                v-model="formData.idName"
                placeholder="请输入专家姓名"
              ></el-input>
            </el-form-item>
            <el-form-item label="身份证号/登录用户名" prop="loginName">
              <el-input
                v-model="formData.loginName"
                placeholder="请输入用户名(输入身份证号，作为登录账号)"
              ></el-input>
            </el-form-item>
            <el-form-item label="手机号" prop="phone">
              <el-input
                v-model="formData.phone"
                placeholder="请输入手机号"
              ></el-input>
            </el-form-item>
            <el-form-item label="密码" prop="pwd">
              <el-input
                v-model="formData.pwd"
                type="password"
                show-password
                auto-complete="new-password"
                placeholder="请输入密码"
              ></el-input>
            </el-form-item>
            <el-form-item label="确认密码" prop="cPwd">
              <el-input
                v-model="formData.cPwd"
                type="password"
                show-password
                auto-complete="new-password"
                placeholder="请输入确认密码"
              ></el-input>
            </el-form-item>
            <el-form-item label="邮箱">
              <el-input
                v-model="formData.email"
                placeholder="请输入邮箱"
              ></el-input>
            </el-form-item>
            <el-form-item label="备注">
              <el-input
                v-model="formData.intro"
                type="textarea"
                :rows="4"
                placeholder="请填写备注"
              ></el-input>
            </el-form-item>
          </el-form>
        </vue-scroll>
      </div>
      <div slot="footer" class="footer-btns-big">
        <el-button
          type="primary"
          @click="handleDialogAction('confirm')"
          :loading="actionLoading"
          >确 定</el-button
        >
        <el-button type="danger" @click="handleDialogAction('cancel')"
          >取 消</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { ops } from "@/utils/scrollIndialog";
import { requiredItem, numberRequired } from "@/assets/js/formRules";
import { postExpert, putExpert } from "@/api/export/index";
import { filterIdNumber } from "@/utils/yioks_filter";
import { isIdNumber } from "@/assets/js/formRules"
import yioksRules from "@/utils/formRules/rules";
import auth from "@/api/auth";
import JSEncrypt from "@/assets/js/jsencrypt.min.js";

export default {
  props: {
    isShow: {
      type: Boolean,
      required: true,
      default: false,
    },
    defaultInfo: {
      type: Object,
      required: false,
      default: () => {
        return {};
      },
    },
    isEdit: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {
      ops,
      formData: {
        idName: "",
        loginName: "",
        pwd: "",
        cPwd: "",
        email: "",
        phone: "",
        intro: "",
      },
      actionLoading: false,
      editUuid: "",
    };
  },

  computed: {
    formRules() {
      if (this.isEdit) {
        return {
          idName: [requiredItem("专家姓名")],
          loginName: [requiredItem("身份证号")],
          phone: [requiredItem("手机号")],
        };
      } else {
        return {
          idName: [requiredItem("专家姓名")],
          loginName: [requiredItem("身份证号"), isIdNumber()],
          phone: [requiredItem("手机号")],
          pwd: [
            requiredItem("密码"),
            {
              validator: (rule, val, cb) => {
                const { pwd, cPwd } = this.formData;
                if (val) {
                  if (yioksRules.password(val)) {
                    if (cPwd) {
                      if (cPwd === val) {
                        cb();
                      } else {
                        cb(new Error("密码不一致"));
                      }
                    } else {
                      cb();
                    }
                  } else {
                    cb(
                      new Error("请输入8-16位字符,字母(区分大小写)和数字组合")
                    );
                  }
                } else {
                  cb(new Error("请输入密码"));
                }
              },
              trigger: "change",
            },
          ],
          cPwd: [
            requiredItem("确认密码"),
            {
              validator: (rule, val, cb) => {
                const { pwd, cPwd } = this.formData;
                if (val) {
                  if (yioksRules.password(val)) {
                    if (pwd) {
                      if (pwd === val) {
                        cb();
                      } else {
                        cb(new Error("密码不一致"));
                      }
                    } else {
                      cb();
                    }
                  } else {
                    cb(
                      new Error("请输入8-16位字符,字母(区分大小写)和数字组合")
                    );
                  }
                } else {
                  cb(new Error("请输入密码"));
                }
              },
              trigger: "change",
            },
          ],
        };
      }
    },
  },

  created() {
    if (this.isEdit) {
      const { uuid, idName, intro, phone, email, idNumber } = this.defaultInfo;
      this.formData = Object.assign({}, this.formData, {
        intro,
        phone,
        email,
        loginName: idNumber,
        idName,
      });
      this.editUuid = uuid;
    }
  },

  methods: {
    handleBeforeClose() {
      this.setDialogStatus(false);
    },

    setDialogStatus(flag) {
      this.$emit("update:isShow", flag);
    },

    async handleDialogAction(flag) {
      if (flag == "confirm") {
        // this.$emit("callback", true, true);
        this.actionLoading = true;
        this.$refs["expertForm"].validate(async (valid) => {
          if (valid) {
            const { pwd, intro, email, loginName, ...rest } = this.formData;
            let password = "";
            if (pwd) {
              try {
                // 密码加密
                const publicKey = await auth.getPublicKey(loginName);
                let encryptor = new JSEncrypt();
                encryptor.setPublicKey(publicKey);
                password = encryptor.encrypt(pwd);
              } catch (err) {
                console.error("err", err);
              }
            }
            let postData = {
              expert: {
                intro: intro,
              },
              userForm: {
                ...rest,
                idNumber: loginName,
                loginName: loginName,
                gender: filterIdNumber(loginName, 1),
                // password,
              },
            };
            if(email) postData.userForm.email = email;
            if (password) postData.userForm.password = password;
            if (this.editUuid) postData.expert.uuid = this.editUuid;
            let requestName = postExpert;
            if (this.isEdit) {
              requestName = putExpert;
            }
            requestName(postData)
              .then((res) => {
                this.actionLoading = false;
                if (res.code) {
                  this.$message.error(res.msg);
                  return;
                }
                this.$emit("callback", true, true);
              })
              .catch((err) => {
                this.actionLoading = false;
                console.error("err", err);
                this.$emit("callback", true, false);
              });
          } else {
            this.actionLoading = false;
          }
        });
      } else if (flag == "cancel") {
        this.$emit("callback", false, true);
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
@import '~@/assets/css/yioks_page_table'
.expert-action-wrapper
  height 480px
.expert-form
  margin-right 160px
</style>